import React, { Suspense } from "react"
import { LoadingSpinner } from "@kit/design/loading-spinner"
import Drawer from "@kit/design/drawer"

import {
  setSubscriberProfileId,
  useSubscriberProfileId
} from "./use-subscriber-profile-id"

const ProfileDrawerContent = React.lazy(() =>
  import("./components/profile-drawer-content").then(m => ({
    default: m.ProfileDrawerContent
  }))
)

export function SubscriberProfileDrawer() {
  const subscriberProfileId = useSubscriberProfileId()
  const subscriberId = subscriberProfileId ? Number(subscriberProfileId) : null

  if (!subscriberProfileId) {
    return null
  }

  const onClose = () => {
    setSubscriberProfileId(null)
  }

  return (
    <Drawer onClose={onClose} label="Subscriber Profile">
      <Suspense
        fallback={
          <span role="status" aria-label="Loading subscriber profile">
            <LoadingSpinner />
          </span>
        }
      >
        <ProfileDrawerContent subscriberId={subscriberId} />
      </Suspense>
    </Drawer>
  )
}
